import React from "react";
import styled from "styled-components";
import CallChatMessage from "./CallChatMessage";
import { useAuthService } from "../../Context/AuthContext";
import { createDateSeparators } from "../../Helpers/chatHelper/ChatHelper";
import { useTolgee } from "@tolgee/react";
import SpinnerComponent from "../GenericComponents/SpinnerComponent";

const CallChatMessagesList = ({ messages, callInfo, isLoading, messagesEndRef, isPanelViewer, handleReactToMessage, handleRemoveOwnMessageReaction, displayRightClickMenu, handleShowFullScreenImg }) => {
  const { user } = useAuthService();
  const tolgee = useTolgee();
  const currentLanguage = tolgee.getLanguage() || 'en';

  const messagesWithSeparators = createDateSeparators(messages, currentLanguage);
  const isConferenceCall = !!callInfo?.conference_id;

  if (isLoading) {
    return (
      <LoadingContainer>
        <SpinnerComponent isLoading={true} />
      </LoadingContainer>
    );
  }

  return (
      <MessagesWrapper>
        {messagesWithSeparators.map((item, index) => {
          if (item.type === "date-separator") {
            return (
              <DateSeparator key={`separator-${index}`}>
                <DateLine />
                <DateText>{item.date}</DateText>
                <DateLine />
              </DateSeparator>
            );
          }

          const isOwnMessage = item.user_id === user?.id;
          
          return (
            <CallChatMessage
              key={item.id}
              message={item}
              isOwnMessage={isOwnMessage}
              callInfo={callInfo}
              isConferenceCall={isConferenceCall}
              isPanelViewer={isPanelViewer}
              handleReactToMessage={handleReactToMessage}
              handleRemoveOwnMessageReaction={handleRemoveOwnMessageReaction}
              displayRightClickMenu={displayRightClickMenu}
              handleShowFullScreenImg={handleShowFullScreenImg}
            />
          );
        })}
        
        <div ref={messagesEndRef} />
      </MessagesWrapper>
  );
};

export default CallChatMessagesList;

const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding-bottom: 10px;
  margin-top: auto;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const DateSeparator = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
  width: 100%;
`;

const DateLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.sidebar.borderColor};
`;

const DateText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  white-space: nowrap;
`;